function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 198.46 184.04",
    style: {
      enableBackground: "new 0 0 198.46 184.04"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDF48"
    },
    points: "59.6,111.514 4.962,67.871 75.745,65.958 99.23,4.601 122.716,65.958 193.499,67.871  138.861,111.514 156.567,179.439 99.23,142.265 41.894,179.439  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.0378,
    y1: 106.0633,
    x2: 170.044,
    y2: 51.8892
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0063,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    style: {
      stopColor: "#573027"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_1_)"
    },
    points: "192.426,67.842 122.72,65.958 99.644,98.356  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061458285156235092320000010969677006287165829_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.8294,
    y1: 51.5466,
    x2: 166.6633,
    y2: 51.5466
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0094,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2545,
    style: {
      stopColor: "#CEC9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8145,
    style: {
      stopColor: "#55423F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C1410"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000061458285156235092320000010969677006287165829_)"
    },
    points: "99.644,98.356  122.72,65.958 122.716,65.958 99.23,4.601 99.23,98.492  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098212020130851101890000000874583880089005759_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.5644,
    y1: 102.7172,
    x2: 149.5577,
    y2: 156.1744
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0063,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    style: {
      stopColor: "#573027"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000098212020130851101890000000874583880089005759_)"
    },
    points: "99.427,98.661  99.252,98.906 156.55,179.428 156.567,179.439 138.861,111.514  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151540215186521696730000013001319781106205356_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.7806,
    y1: 188.2917,
    x2: 98.7639,
    y2: 118.5315
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#481F05"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AE857B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000151540215186521696730000013001319781106205356_)"
    },
    points: "99.23,98.938  99.23,142.266 156.55,179.428 99.252,98.907  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173852194839672373700000005999129427597321363_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.0348,
    y1: 172.8505,
    x2: 104.8923,
    y2: 106.1125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#481F05"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AE857B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000173852194839672373700000005999129427597321363_)"
    },
    points: "41.896,179.43  41.894,179.439 99.23,142.265 99.23,98.937  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081615685901161284670000000590387299624453532_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.1925,
    y1: 106.3785,
    x2: 228.9136,
    y2: 65.9444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0094,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2545,
    style: {
      stopColor: "#CEC9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8145,
    style: {
      stopColor: "#55423F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C1410"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000081615685901161284670000000590387299624453532_)"
    },
    points: "99.427,98.661  138.861,111.514 193.499,67.871 192.426,67.842 99.644,98.356  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016761553931903272280000007744971836681817473_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.7733,
    y1: 109.2096,
    x2: 20.9399,
    y2: 185.4764
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0094,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2545,
    style: {
      stopColor: "#CEC9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8145,
    style: {
      stopColor: "#55423F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C1410"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000016761553931903272280000007744971836681817473_)"
    },
    points: "99.23,98.876  99.009,98.565 59.596,111.527 41.896,179.43 99.23,98.937  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101091070145584160270000009653084800427414183_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.1111,
    y1: 51.5728,
    x2: 103.6971,
    y2: 51.5728
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFCAC4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    style: {
      stopColor: "#977168"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.67,
      fill: "url(#SVGID_00000101091070145584160270000009653084800427414183_)"
    },
    points: "99.071,98.545  99.23,98.492 99.23,4.601 75.766,65.902 98.972,98.512  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064328294165436644960000017810604063503757996_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.8667,
    y1: 100.9774,
    x2: 19.6571,
    y2: 51.0243
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0063,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    style: {
      stopColor: "#573027"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000064328294165436644960000017810604063503757996_)"
    },
    points: "75.766,65.902  75.745,65.958 4.962,67.871 4.962,67.871 98.972,98.512  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034807735529939169400000001994485495011451826_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.9617,
    y1: 89.6991,
    x2: 99.009,
    y2: 89.6991
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#481F05"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AE857B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000034807735529939169400000001994485495011451826_)"
    },
    points: "98.972,98.512  4.962,67.871 59.6,111.514 59.596,111.527 99.009,98.565  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.fee03851cc41a54a99ed08b9f092a54a.svg";
export { ForwardRef as ReactComponent };